// =============================================================================
// GENERATED by scripts/build-shared.cjs from functions/src/shared/safetyHold.js
// DO NOT EDIT — edit the canonical file and re-run `node scripts/build-shared.cjs`.
// (TASK-9657 S0: ONE safety-hold rule — dispatch board, connector, buildAsset.)
//
// Side-effect module: attaches `window.SafetyHold`. dispatch.js (board holds)
// and maintenance.js (getActiveHoldForAsset) read it at CALL time.
//
// The body below is the canonical file's PORTABLE CORE, copied byte for byte.
// =============================================================================
(function () {
  'use strict';

  var SAFETY_HOLD_SOURCE_VEHICLE = 'maintenance hold';
  var SAFETY_HOLD_SOURCE_CRITICAL = 'open critical maintenance item';

  /**
   * wo-legacy-followups — the old app's IMPORTED work-order shape (kind / text, no
   * assetType / truckId / trailerId). Its `assetId` is the OLD app's row number,
   * not a DispatchDeck id: the old app numbered trucks and trailers separately, so
   * the same number names a truck AND a trailer. It is never used as a fleet ref.
   * Twin of shared/legacyWorkOrder.js isLegacyWorkOrder (pinned equal by
   * tests/wo-legacy-followups.unit.cjs) — kept here so a caller that forgets to
   * inject the name resolver attaches it to NO unit, never to a wrong one (callers
   * say how many such orders exist: maintenanceAssets.unattributedLegacyCritical).
   */
  function isLegacyOrderShape(t) {
    if (!t || typeof t !== 'object') return false;
    if (t.assetType || t.truckId || t.trailerId) return false;
    return typeof t.text === 'string' || typeof t.kind === 'string';
  }

  /** (2) An open critical maintenance item — the board's test, NOT isMaintOpen. */
  function isCriticalHoldTask(task) {
    return !!task && typeof task === 'object' && task.priority === 'critical' && task.status !== 'completed';
  }

  /** (1) An active vehicleHolds doc covering `dayKey` (company-local YYYY-MM-DD). */
  function vehicleHoldCoversDay(hold, dayKey) {
    if (!hold || typeof hold !== 'object' || hold.status !== 'active') return false;
    if (typeof dayKey !== 'string' || !dayKey) return false;
    if (typeof hold.startDate !== 'string' || typeof hold.endDate !== 'string') return false;
    return hold.startDate <= dayKey && hold.endDate >= dayKey;
  }

  /** The first of `dayKeys` the hold covers, or null. */
  function vehicleHoldFirstDay(hold, dayKeys) {
    var keys = Array.isArray(dayKeys) ? dayKeys : [dayKeys];
    for (var i = 0; i < keys.length; i++) {
      if (vehicleHoldCoversDay(hold, keys[i])) return keys[i];
    }
    return null;
  }

  /**
   * Every unit on a safety hold on ANY of `dateKeys`.
   * o = { vehicleHolds, tasks, fleets: { trucks, trailers, assets }, dateKeys, resolveFleetRef, resolveLegacy? }
   * resolveLegacy(task) -> { kind, v } | null: the unit an IMPORTED order names
   * (shared/legacyWorkOrder.js resolveLegacyVehicle over the WHOLE non-deleted
   * fleet, injected by the caller). Without it an imported order holds no unit.
   * Returns Map(`truck:<id>` | `trailer:<id>` | `asset:<id>` ->
   *   { source: 'maintenance hold', endDate } | { source: 'open critical maintenance item' }).
   * A maintenance hold wins over a critical item on the same unit.
   */
  function safetyHoldsForDays(o) {
    var opts = o || {};
    var fleets = opts.fleets || {};
    var resolveFleetRef = opts.resolveFleetRef;
    var dateKeys = Array.isArray(opts.dateKeys) ? opts.dateKeys : [];
    var byUnit = function (a, b) { return String(a.unit || a.name || '').localeCompare(String(b.unit || b.name || '')); };
    var byName = function (a, b) { return String(a.name || '').localeCompare(String(b.name || '')); };
    var lists = [
      ['truck', (fleets.trucks || []).slice().sort(byUnit)],
      ['trailer', (fleets.trailers || []).slice().sort(byUnit)],
      ['asset', (fleets.assets || []).slice().sort(byName)]
    ];
    var listOf = function (kind) {
      for (var i = 0; i < lists.length; i++) if (lists[i][0] === kind) return lists[i][1];
      return [];
    };
    var resolve = function (refs) {
      for (var r = 0; r < refs.length; r++) {
        var ref = refs[r];
        if (ref === null || ref === undefined || ref === '') continue;
        for (var l = 0; l < lists.length; l++) {
          var item = resolveFleetRef(ref, lists[l][1]);
          if (item) return lists[l][0] + ':' + item.id;
        }
      }
      return null;
    };
    var out = new Map();
    var holds = Array.isArray(opts.vehicleHolds) ? opts.vehicleHolds : [];
    for (var h = 0; h < holds.length; h++) {
      var x = holds[h];
      if (!vehicleHoldFirstDay(x, dateKeys)) continue;
      var kind = x.assetType === 'trailer' ? 'trailer' : (x.assetType === 'truck' ? 'truck' : null);
      if (!kind) continue;
      var list = listOf(kind);
      var hit = resolveFleetRef(x.assetId, list) || resolveFleetRef(x.assetUnit, list);
      if (hit) out.set(kind + ':' + hit.id, { source: SAFETY_HOLD_SOURCE_VEHICLE, endDate: x.endDate });
    }
    var tasks = Array.isArray(opts.tasks) ? opts.tasks : [];
    for (var t = 0; t < tasks.length; t++) {
      var m = tasks[t];
      if (!isCriticalHoldTask(m)) continue;
      var k = null;
      if (isLegacyOrderShape(m)) {
        // By NAME only — never its assetId (an old row number) or a unit-string guess.
        var lh = typeof opts.resolveLegacy === 'function' ? opts.resolveLegacy(m) : null;
        if (lh && lh.v && (lh.kind === 'truck' || lh.kind === 'trailer' || lh.kind === 'asset')) {
          var held = listOf(lh.kind);
          for (var q = 0; q < held.length; q++) if (held[q] && held[q].id === lh.v.id) { k = lh.kind + ':' + lh.v.id; break; }
        }
      } else {
        k = resolve([m.truckId, m.trailerId, m.assetId]) || resolve([m.assetUnit]);
      }
      if (k && !out.has(k)) out.set(k, { source: SAFETY_HOLD_SOURCE_CRITICAL });
    }
    return out;
  }

  window.SafetyHold = Object.freeze({
    SOURCE_VEHICLE: SAFETY_HOLD_SOURCE_VEHICLE,
    SOURCE_CRITICAL: SAFETY_HOLD_SOURCE_CRITICAL,
    isCriticalHoldTask: isCriticalHoldTask,
    isLegacyOrderShape: isLegacyOrderShape,
    vehicleHoldCoversDay: vehicleHoldCoversDay,
    vehicleHoldFirstDay: vehicleHoldFirstDay,
    safetyHoldsForDays: safetyHoldsForDays
  });
})();
